export default class UtilsCaching {

    constructor() {
  
    }

    //Per caching
    static generateKey(args)
    {
        let result = "";
        for (const arg of args)
        {
        result += encodeURIComponent(arg.toString());
        }

        return result;
    }

    //Controlla la cache dell'oggetto specificato e ritorna un risultato nel caso esista
    static getStorageResult(args, lastUpdate)
    {
        const key = this.generateKey(args);
        const result = JSON.parse(window.sessionStorage.getItem(key));

        //Se il risultato è piu vecchio dell'ultimo aggiornamento non ritornare nulla
        if (result == null || new Date(result.date) < lastUpdate)
        return null;
        
        return result.data;
    }

    static saveResultInStorage(result, args)
    {    
        const key = this.generateKey(args);

        //Crea l'oggetto da mantenere in memoria
        const obj = {
        data: result,
        date: new Date().toJSON(),
        }
        try {
            window.sessionStorage.setItem(key, JSON.stringify(obj));
        } catch (error)
        {
            console.log('Error while saving to cache. Cleaning up');

            const maxDim = 5 * 1024 * 1024; //5mb, il massimo disponibile per la maggior parte dei browser.
            //Calcola la dimensione dell'oggetto
            const objSize = JSON.stringify(obj).length;
            
            const storedArray = [];
            for (const key of Object.keys(window.sessionStorage))
            {
                storedArray.push({
                    key: key,
                    value: JSON.parse(window.sessionStorage[key]),
                })
            }

            //Una volta ottenuto l'array ordinalo per data (in ordine decrescente per sfruttare le proprietà della pop)
            storedArray.sort((a,b) => a.value.date > b.value.date ? -1 : 1);

            //Finchè non si libera abbastanza spazio elimina ciascun componente
            while (JSON.stringify(window.sessionStorage).length + objSize > maxDim)
            {
                const thisItem = storedArray.pop();
                window.sessionStorage.removeItem(thisItem.key);
            }

            //Una volta soddisfatta questa condizione aggiungi il nuovo oggetto
            console.log('Cache cleanup complete');
            window.sessionStorage.setItem(key, JSON.stringify(obj));
            //const storedArray = JSON.parse(sessionStorage.getItem("items"));
        }
        
    }
}